/**
 * Created by noOne on 05/09/2017.
 */

import Enemy from "./Enemy";

export default class EnemySpawner {
    constructor(pos) {
        /**
         * @type {PIXI.Point}
         * @private
         */
        this._position = new PIXI.Point(pos.x, pos.y);
    }

    emitter() {
        var emitEnemy = ()=> {
            const enemy = new Enemy("enemy");
            enemy.x = this.x;
            enemy.y = this.y;
            Common.sprites.push(enemy);
            Common.spriteHolder.addChild(enemy.view);
            Common.enemies.push(enemy);
            enemy.view.alpha = 0;
            TweenMax.to(enemy.view, 0.15, {alpha: 1, ease: Power2.easeIn});
            delay(emitEnemy, 5, this);
        };
        delay(emitEnemy, 5, this);
    }

    get x() {
        return this._position.x;
    }

    set x(float) {
        this._position.x = float;
    }

    get y() {
        return this._position.y;
    }

    set y(float) {
        this._position.y = float;
    }

}